<template>
  <div class="user">
    <div class="photo">
      <img :src="currentUser.avatar_url"/>
    </div>
    <div class="info">
      <a data-toggle="collapse" @click="toggleMenu" href="javascript:void(0)">
           <span>
             {{ firstName() }}
             <b class="caret"></b>
          </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <li>
              <router-link to="/editar-perfil" tag="li">
                <a href="javascript:void(0)">
                  <!-- <span class="sidebar-mini">PE</span> -->
                  <span class="sidebar-normal">Editar Perfil</span>
                </a>
              </router-link>
            </li>
            <li>
              <a @click="logoutUser()" href="javascript:void(0)">
                <!-- <span class="sidebar-mini">Sa</span> -->
                <span class="sidebar-normal">Sair</span>
              </a>
            </li>
          </ul>
        </el-collapse-transition>
        <!-- <div class="button-container">
          <button @click="openForms" type="button" class="btn btn-sm btn-danger-custom">Autoavaliação (Opcional)</button>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    data () {
      return {
        isClosed: true
      }
    },
    methods: {
      toggleMenu () {
        this.isClosed = !this.isClosed
      },
      logoutUser () {
        this.$store.commit('logout')
        this.$router.push('/login')
      },
      firstName () {
        let name = this.currentUser.name.split(' ')
        return name[0]
      },
      openForms () {
        window.open('https://forms.office.com/r/KCTMGsuk42', '_blank')
      }
    },
    computed: {
      currentUser () {
        return this.$store.getters.currentUser
      }
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
  .button-container {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
  .btn-danger-custom {
    background-color: red !important;
    color: white !important;
    border-color: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/UserMenu.vue